// Time is stored as whole minutes; people think in hours AND minutes. These
// helpers convert at the UI edge so nothing downstream deals in fractions.

// 150 -> "2h 30m" · 45 -> "45m" · 120 -> "2h" · 0 -> "0m"
export const formatMinutes = (mins) => {
  if (mins == null) return '—';
  const total = Math.max(0, Math.round(mins));
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
};

export const splitMinutes = (mins) => ({
  hours: mins == null ? '' : String(Math.floor(mins / 60)),
  minutes: mins == null ? '' : String(mins % 60),
});

// Empty in BOTH boxes means "not set" (null) — distinct from an explicit 0.
export const joinMinutes = (hours, minutes) => {
  const h = String(hours ?? '').trim();
  const m = String(minutes ?? '').trim();
  if (h === '' && m === '') return null;
  return (Number(h) || 0) * 60 + (Number(m) || 0);
};

export const totalLogged = (todo) =>
  (todo.timeLogs || []).reduce((sum, l) => sum + (l.minutes || 0), 0);

// Two compact boxes. The unit lives INSIDE each box as its placeholder
// ("hh" / "mm") rather than as separate labels beside them, so the pair stays
// small and reads like a time field.
function HoursMinutesInput({ label, hours, minutes, onChange, helperText, autoFocus }) {
  return (
    <div className="ds-field hm-field">
      {label && <label className="ds-field-label">{label}</label>}
      <div className="hm-inputs">
        <input
          className="ds-input hm-num"
          type="number"
          min="0"
          placeholder="hh"
          aria-label="Hours"
          value={hours}
          autoFocus={autoFocus}
          onChange={(e) => onChange(e.target.value, minutes)}
        />
        <span className="hm-sep">:</span>
        <input
          className="ds-input hm-num"
          type="number"
          min="0"
          max="59"
          placeholder="mm"
          aria-label="Minutes"
          value={minutes}
          onChange={(e) => onChange(hours, e.target.value)}
        />
      </div>
      {helperText && <span className="ds-field-helper">{helperText}</span>}
    </div>
  );
}

export default HoursMinutesInput;
